import { DownOutlined } from '@ant-design/icons';
import { Button, Popover } from 'antd';
import { FC, Key, ReactNode } from 'react';
import styles from './index.module.less';
import V2Tag from 'src/common/components/Data/V2Tag/index';

interface TagsProps {
  showCount?: number;
  items?: TagItem[];
  columns?: { status?: number, title?: string }[];
  title?: ReactNode;
  isPopover?: boolean;
  controlMore?: boolean; // 是否根据标签数量控制展示更多
};

interface TagItem {
  key?: Key
  color?: string;
  content?: ReactNode;
  status?: number;
};


const renderTags = (tags: TagItem[]) => {
  if (!Array.isArray(tags)) {
    return;
  }

  return (
    tags.map(tag => {
      const { color, content, key } = tag;
      return (<V2Tag color={color} key={key} style={{ marginBottom: '2px', display: 'inline-block' }}>{content}</V2Tag>);
    })
  );
};

const getTagsByStatus = (columns, items) => {
  return columns.map(column => {
    const { title, status } = column;
    return {
      title,
      items: items.filter(item => item.status === status)
    };
  });
};


export const renderPopover = (items: { title?: string, items?: TagItem[] }[]) => {
  return items.map((item, index) => {
    const { title, items = [] } = item;
    return (
      <div className={styles['popover-wrapper']} key={index}>
        {!!items.length && (<span className={styles['popover-title']}>{title}</span>)}
        <div className={styles['popover-content']}>{renderTags(items!)}</div>
      </div>
    );
  });
};


const Tags : FC<TagsProps> = ({ items = [], showCount = 3, title, columns, isPopover = true, controlMore = false }) => {
  const oneLineItems = items.slice(0, showCount);
  const otherItems = items.slice(0,);
  const content = renderPopover(getTagsByStatus(columns, otherItems));
  return (
    <>
      {renderTags(oneLineItems)}
      {
        isPopover && (
          <Popover
            title={title}
            content={content}
            arrowPointAtCenter
            placement='bottomRight'>
            {!!otherItems.length && (controlMore ? items.length > showCount : true) && <Button size='small' type='link'><DownOutlined style={{ color: '#999' }} /></Button>}
          </Popover>
        )
      }
    </>
  );
};

export default Tags;
